import type { SVGProps } from "react";

export const Fireflies = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 21 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Fireflies</title>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__a"
        x1="16.868"
        x2="-10.77"
        y1="18.512"
        y2="-10.526"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.113" stopColor="#DE2D7A" />
        <stop offset="0.3" stopColor="#C5388F" />
        <stop offset="0.54" stopColor="#9B4AB0" />
        <stop offset="0.818" stopColor="#6262DE" />
        <stop offset="0.994" stopColor="#3B73FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__b"
        x1="16.964"
        x2="-10.674"
        y1="18.423"
        y2="-10.616"
      >
        <stop stopColor="#FF3C82" />
        <stop offset="0.103" stopColor="#F53E88" />
        <stop offset="0.274" stopColor="#DC4598" />
        <stop offset="0.492" stopColor="#B251B2" />
        <stop offset="0.745" stopColor="#7961D7" />
        <stop offset="0.994" stopColor="#3B73FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__c"
        x1="21.555"
        x2="12.19"
        y1="14.055"
        y2="-19.882"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.113" stopColor="#DE2D7A" />
        <stop offset="0.3" stopColor="#C5388F" />
        <stop offset="0.54" stopColor="#9B4AB0" />
        <stop offset="0.818" stopColor="#6262DE" />
        <stop offset="0.994" stopColor="#3B73FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__d"
        x1="12.338"
        x2="-21.187"
        y1="22.824"
        y2="12.611"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.113" stopColor="#DE2D7A" />
        <stop offset="0.3" stopColor="#C5388F" />
        <stop offset="0.54" stopColor="#9B4AB0" />
        <stop offset="0.818" stopColor="#6262DE" />
        <stop offset="0.994" stopColor="#3B73FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__e"
        x1="-2.429"
        x2="6.961"
        y1="-6.152"
        y2="15.365"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.114" stopColor="#DE286E" />
        <stop offset="0.303" stopColor="#C52361" />
        <stop offset="0.544" stopColor="#9B1A4D" />
        <stop offset="0.825" stopColor="#620F30" />
        <stop offset="0.994" stopColor="#3D081E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__f"
        x1="5.359"
        x2="14.749"
        y1="1.727"
        y2="23.245"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.114" stopColor="#DE286E" />
        <stop offset="0.303" stopColor="#C52361" />
        <stop offset="0.544" stopColor="#9B1A4D" />
        <stop offset="0.825" stopColor="#620F30" />
        <stop offset="0.994" stopColor="#3D081E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__g"
        x1="-1.397"
        x2="19.87"
        y1="1.383"
        y2="15.511"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.114" stopColor="#DE286E" />
        <stop offset="0.303" stopColor="#C52361" />
        <stop offset="0.544" stopColor="#9B1A4D" />
        <stop offset="0.825" stopColor="#620F30" />
        <stop offset="0.994" stopColor="#3D081E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="fireflies_svg__h"
        x1="-464.769"
        x2="-461.125"
        y1="461.172"
        y2="489.944"
      >
        <stop stopColor="#E82A73" />
        <stop offset="0.114" stopColor="#DE286E" />
        <stop offset="0.303" stopColor="#C52361" />
        <stop offset="0.544" stopColor="#9B1A4D" />
        <stop offset="0.825" stopColor="#620F30" />
        <stop offset="0.994" stopColor="#3D081E" />
      </linearGradient>
    </defs>
    <path d="M7.36 2H.787v6.527H7.36z" fill="url(#fireflies_svg__a)" />
    <path d="M15.149 9.88H8.574v6.526h6.575z" fill="url(#fireflies_svg__b)" />
    <path
      d="M15.149 2H8.574v6.527h12.212v-.933a5.57 5.57 0 0 0-1.651-3.956A5.66 5.66 0 0 0 15.15 2z"
      fill="url(#fireflies_svg__c)"
    />
    <path
      d="M.786 9.88v6.526c0 1.484.594 2.907 1.65 3.956A5.66 5.66 0 0 0 6.423 22h.939V9.88z"
      fill="url(#fireflies_svg__d)"
    />
    <path
      d="M.786 2 7.36 8.527H.786z"
      fill="url(#fireflies_svg__e)"
      opacity="0.18"
    />
    <path
      d="m8.574 9.88 6.575 6.526H8.574z"
      fill="url(#fireflies_svg__f)"
      opacity="0.18"
    />
    <path
      d="M.786 16.406c0 1.484.594 2.907 1.65 3.956A5.66 5.66 0 0 0 6.423 22h.939V9.88z"
      fill="url(#fireflies_svg__g)"
      opacity="0.18"
    />
    <path
      d="M15.15 2c1.494 0 2.928.59 3.985 1.638a5.57 5.57 0 0 1 1.65 3.956v.933H8.576z"
      fill="url(#fireflies_svg__h)"
      opacity="0.18"
    />
  </svg>
);

export default Fireflies;
